export const getVueDatePickLocale = (lang: string) => {
    const locale: any = {
        ru: {
            nextMonthCaption: 'Следюущий месяц',
            prevMonthCaption: 'Предыдущий месяц',
            setTimeCaption: 'Установить время',
            weekdays: [
                'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'
            ],
            months: [
                'Январь', 'Февраль', 'Март', 'Апрель',
                'Май', 'Июнь', 'Июль', 'Август',
                'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
            ],
            displayFormat: 'DD.MM.YYYY',
        },
        en: {
            displayFormat: 'YYYY-MM-DD',
            nextMonthCaption: 'Next month',
            prevMonthCaption: 'Previous month',
            setTimeCaption: 'Set time:',
            weekdays: [
                'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'
            ],
            months: [
                    'January', 'February', 'March', 'April',
                    'May', 'June', 'July', 'August',
                    'September', 'October', 'November', 'December'
            ]
        },
        uk: {
            displayFormat: 'DD.MM.YYYY',
            nextMonthCaption: 'Следюущій місяць',
            prevMonthCaption: 'Попередній місяць',
            setTimeCaption: 'Встановити час:',
            weekdays: [
                'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'
            ],
            months: [
                'Січень', 'Лютий', 'Березень', 'Квітень',
                 'Травень', 'Червень', 'Липень', 'Серпень',
                 'Вересень', 'Жовтень', 'Листопад', 'Грудень'
            ]
        },
        zh: {
            displayFormat: 'YYYY-MM-DD',
            nextMonthCaption: '下个月',
            prevMonthCaption: '前一个月',
            setTimeCaption: '设置时间:',
            weekdays: [
                '周一', '周二', '周三', '周四', '周五', '周六', '周日'
            ],
            months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
        }
    }

    if (!locale[lang]) {
        lang = 'en';
    }
    return locale[lang];
}